import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createRowCopy.success: {
            return { ...action.payload, responseStatus: 'success' };
        }

        case constants.createRowCopy.error: {
            return { ...action.payload, responseStatus: 'error' };
        }

        case constants.createRowCopy.try: {
            return initialState;
        }

        default:
            return state;
    }
}